import { withStyles } from '@material-ui/styles';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import type { OnlineClinicService } from 'tm3-core/api.dtos';
import ServiceCard from './controls/service-card';
import styles from './styles';

interface IProps {
  classes: {
    serviceContainer: string;
  };
  services: OnlineClinicService[];
  onClick: (service: OnlineClinicService) => void;
}

@observer
class Services extends React.Component<IProps> {
  render() {
    const { serviceContainer } = this.props.classes;

    return <div className={serviceContainer}>{this.renderServices()}</div>;
  }

  renderServices() {
    const { services } = this.props;
    return services.map((service: OnlineClinicService, i: number) => {
      return <ServiceCard key={i} service={service} onClick={this.onClick} />;
    });
  }

  @action.bound
  onClick(service: OnlineClinicService) {
    this.props.onClick(service);
  }
}

export default withStyles(styles)(Services);
